import { TownsquareSiteAri, TownsquareTagAri } from '@atlassian/ari';
import { getSiteId } from '@atlassian/projects-goals-common/get-site-id';
import { PreloadedQuery } from 'react-relay';

import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import UpdatesTabAggQuery, {
	type UpdatesTabAggQuery as UpdatesTabAggQueryType,
} from '../ui/Updates/agg/__generated__/UpdatesTabAggQuery.graphql';

export const topicUpdatesAggResource: RouteResource<
	PreloadedQuery<UpdatesTabAggQueryType, Record<string, unknown>>
> = createRelayResource<UpdatesTabAggQueryType>({
	getQuery: (routerContext, resourceContext): RelayResourceConfig<UpdatesTabAggQueryType> => {
		const { collabContext } = resourceContext as ResourceContext;
		const siteId = getSiteId('site', collabContext?.contextId ?? '');
		const tagUuid = routerContext?.match?.params?.uuid ?? '';
		const tabName = routerContext?.match?.params?.tabName ?? '';

		return {
			query: UpdatesTabAggQuery,
			variables: {
				tagId: TownsquareTagAri.create({
					tagUuid,
					siteId,
				}).toString(),
				containerId: TownsquareSiteAri.create({ siteId }).toString(),
				shouldFetchUpdatesTabData: tabName === 'updates',
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
